import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    InvoiceSetupContainerComponent,
    InvoiceSelectionsComponent,
    InvoiceAddressComponent,
    InvoiceSessionComponent,
    InvoiceComponent,
    InvoiceAddressAddComponent
} from './';
import { InvoiceSetupRoute } from './invoice-setup.route';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../../shared/shared.module';
import { InvoiceSelectionAddComponent } from './invoice-selections/invoice-selection-add/invoice-selection-add.component';
import { InvoiceSetupPresenterComponent } from './invoice-setup-presenter/invoice-setup-presenter.component';
import { InvoiceSetupFiltersPresenterComponent } from './invoice-setup-filters-presenter/invoice-setup-filters-presenter.component';
import { InvoiceSetupFiltersContainerComponent } from './invoice-setup-filters-container/invoice-setup-filters-container.component';
import { InvoiceSetupUpdateDialogComponent } from './invoice-setup-update-dialog/invoice-setup-update-dialog.component';
import { InvoiceSessionUpdateDialogComponent } from './invoice-session-update-dialog/invoice-session-update-dialog.component';

@NgModule({
    declarations: [
        InvoiceSetupContainerComponent,
        InvoiceSelectionsComponent,
        InvoiceAddressComponent,
        InvoiceSessionComponent,
        InvoiceComponent,
        InvoiceAddressAddComponent,
        InvoiceSelectionAddComponent,
        InvoiceSetupPresenterComponent,
        InvoiceSetupFiltersPresenterComponent,
        InvoiceSetupFiltersContainerComponent,
        InvoiceSetupUpdateDialogComponent,
        InvoiceSessionUpdateDialogComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [InvoiceSetupRoute]
        })
    ]
})
export class InvoiceSetupModule {}
